import React from 'react';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
import { Heading } from './Heading';
import { Form } from './Form/Form';
import { Info } from './Info/Info';
import { ShippingInfo } from './ShippingInfo';
export const ProductInfo = () => (React.createElement("div", { className: "w:1/2:lg-up" },
    MEDIA_BREAKPOINTS.LG_UP.matches && React.createElement(Heading, null),
    React.createElement(Form, null),
    React.createElement(ShippingInfo, null),
    React.createElement(Info, null)));
